import GeneratedAuditServiceApi from "./generated/GeneratedAuditServiceApi"

class AuditServiceApi extends GeneratedAuditServiceApi {

}

export const auditServiceApi = new AuditServiceApi()
